export default {
    microsoft: 'Microsoft Windows',
    osx: 'Mac OS X',
    ios: 'iOS',
    linux: 'Linux',
    solaris: 'Solaris',
    other: 'Other'
};
